<div class="data-card card">
    <p class="data-card__title">{{ title }}</p>
    <p class="data-card__value">{{ value }}</p>
</div>